// Constants for different requests for current reducer
export default {
  visitLocations: 'VISIT_LOCATIONS',
  createVisitLocation: 'CREATE_VISIT_LOCATION',
  updateVisitLocation: 'UPDATE_VISIT_LOCATION',
  updateVisitLocationStatus: 'UPDATE_VISIT_LOCATION_STATUS',
  deleteVisitLocation: 'DELETE_VISIT_LOCATION',
};
